import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { type MinifiedSharePayload } from '@lib/utils/shareItem';

export interface SharedItemState {
    pending: MinifiedSharePayload | null;
}

const initialState: SharedItemState = {
    pending: null
};

const sharedItemSlice = createSlice({
    name: 'sharedItem',
    initialState,
    reducers: {
        setPendingSharedItem: (state, action: PayloadAction<MinifiedSharePayload>) => {
            state.pending = action.payload;
        },
        clearPendingSharedItem: (state) => {
            state.pending = null;
        }
    }
});

export const { setPendingSharedItem, clearPendingSharedItem } = sharedItemSlice.actions;

export default sharedItemSlice.reducer;
